import Vue from "vue";
import Vuetify from "vuetify/lib";
import es from "vuetify/es5/locale/es";

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: "mdi",
  },
  lang: {
    locales: { es },
    current: "es",
  },
  theme: {
    themes: {
      light: {
        primary: "#E51836",
        primary_dark: "#8A172B",
        accent: "#FED105",
        accent_dark: "#F9A61B",
        black: "#000000",
        success: "#4CAF50",
        warning: "#FFC107",
      },
    },
  },
});
